'use client';
var classes = {"monthsList":"m-2a6c32d","monthsListCell":"m-fe27622f"};

export default classes;
//# sourceMappingURL=MonthsList.module.mjs.map
